export const pushSubscriptionQueryKey = (userId: string) => [
  'push-subscriptions',
  userId,
];
